import React, { useEffect } from "react";
import {
  FloatingHelper,
  FormField,
  EmptyState,
  CustomModalLayout,
  TextButton,
  Heading,
  Modal,
  Text,
  Card,
  Box,
  Page,
  Button,
  Cell,
  Layout,
  Input,
  Image,
  PageSection,
  Badge,
  MarketingLayout,
  AnnouncementModalLayout,
  MarketingPageLayoutContent,
} from "@wix/design-system";
import * as Icons from "./components/lazy-icons";
import "./App.css";
import { ReactTagManager } from "react-gtm-ts";
import { useTranslation } from "react-i18next";
import { identify, track, WIX_APP_ID } from "./analytics";

const tagManagerArgs = {
  code: "GTM-WZQPMC7",
};

function App() {
  const { t } = useTranslation();
  const upgradeUrl = `https://memberships.certifiedcode.us/${window.location.search}`;
  const [isUpgraded, setIsUpgraded] = React.useState(false);

  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [isOpening, setIsOpening] = React.useState(false);
  const [shownSettingsModal, setShownSettingsModal] = React.useState(false);
  const [channelId, setChannelId] = React.useState("");
  const [channelKey, setChannelKey] = React.useState("");
  const [isBusinessAppModalOpened, setIsBusinessAppModalOpened] =
    React.useState(false);
  const [instanceData, setInstanceData] = React.useState({
    instance: {
      isFree: true,
      availablePlans: [],
      instanceId: "",
    },
  });

  useEffect(() => {
    ReactTagManager.init(tagManagerArgs);
    const i = new URLSearchParams(window.location.search).get("instance");
    identify(i);
    track("dashboard_opened");
    setInstance();
    getSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const token = new URLSearchParams(window.location.search).get("token");
  const instance = new URLSearchParams(window.location.search).get("instance");

  if (token) {
    track("install_redirect");
    window.location.href = `https://www.wix.com/installer/install?token=${token}&appId=2cde9463-d402-4ea4-84ab-85a7d8c4d2fb&redirectUrl=https://wix.certifiedcode.io/line-pay-pay-button/_functions/@certifiedcode/base-backend/auth`;
  }

  // if (!instance) {
  //   return null
  // }

  const BASE_URL = `https://wix.certifiedcode.io/line-pay-pay-button/_functions`;


  function setInstance() {
    fetch(BASE_URL + "/@certifiedcode/base-backend/instance", {
      method: "GET",
      headers: {
        Authorization: instance || "",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setInstanceData(data);
        setIsUpgraded(data.instance.isFree === false);
      })
      .catch(() => {});
  }

  function setSettings() {
    // if (isUpgraded) {
    if (!open) {
      // Connecting account - need credentials
      if (channelId === "" || channelKey === "") {
        setShownSettingsModal(true);
        return;
      }
    }
    
    const account = !open
      ? {
          channelId: channelId,
          channelKey: channelKey,
        }
      : {};
      
    setIsOpening(true);
    fetch(BASE_URL + "/settings", {
      method: "POST",
      headers: {
        Authorization: instance || "",
      },
      body: JSON.stringify({
        isEnabled: !open,
        ...account,
      }),
    })
      .then(() => {
        setShownSettingsModal(false);
        setIsOpening(false);
        setOpen(!open);
        setChannelId("");
        setChannelKey("");
      })
      .catch(() => {});
    // } else {
    //   setIsUpgradeModalOpen(true)
    // }
  }

  function disconnectAccount() {
    setIsOpening(true);
    fetch(BASE_URL + "/settings", {
      method: "POST",
      headers: {
        Authorization: instance || "",
      },
      body: JSON.stringify({
        isEnabled: false,
      }),
    })
      .then(() => {
        setIsOpening(false);
        setOpen(false);
        setChannelId("");
        setChannelKey("");
      })
      .catch(() => {});
  }

  function getSettings() {
    setIsOpening(true);
    fetch(BASE_URL + "/settings", {
      method: "GET",
      headers: {
        Authorization: instance || "",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsOpening(false);
        setOpen(data.isEnabled);
      })
      .catch(() => {});
  }

  const isPremiumApp = true;

  return (
    <Page height="100vh">
        <Page.Header
          title={
            <Box gap={"SP2"} verticalAlign="middle">
              <Heading>{t("heading")}</Heading>
            </Box>
          }
          actionsBar={
            <Box gap={"SP2"} direction="horizontal">
              {isPremiumApp ? (
                <Button
                  skin="premium"
                  prefixIcon={<Icons.PremiumFilled />}
                  onClick={() => setIsUpgradeModalOpen(true)}
                >
                  {isUpgraded ? t("manage-plan") : t("accept-cta")}
                </Button>
              ) : (
                <></>
              )}
            </Box>
          }
        />
        <Page.Content>
          <Modal
            isOpen={isBusinessAppModalOpened}
            onRequestClose={() => setIsBusinessAppModalOpened(false)}
            shouldCloseOnOverlayClick
            screen="desktop"
          >
            <CustomModalLayout
              closeButtonProps={{
                skin: "dark",
                size: "small",
                onClick: () => setIsBusinessAppModalOpened(false),
              }}
              showHeaderDivider={false}
              showFooterDivider={false}
              title={t("advanced-title")}
              content={
                <Card>
                  <MarketingPageLayoutContent
                    title={t("advanced-desc")}
                    content={
                      <Text>
                        <ul>
                          <li>{t("li-1")}</li>
                          <li>{t("li-2")}</li>
                          <li>{t("li-3")}</li>
                          <Box
                            alignContent="center"
                            gap="SP1"
                            direction="horizontal"
                          >
                            <li>{t("li-4")}</li>
                            <Badge size="tiny" skin="warningLight">
                              {t("new-badge")}
                            </Badge>
                          </Box>
                        </ul>
                      </Text>
                    }
                    actions={
                      <Layout>
                        <Cell>
                          <Button
                            skin="premium"
                            size="large"
                            as="a"
                            href="https://www.certifiedcode.us/integration/line-pay"
                            target="_blank"
                          >
                            {t("view-pricing")}
                          </Button>
                        </Cell>
                        <Cell>
                          <Text size="tiny">
                            By continuing, you agree to the{" "}
                            <a
                              href="https://www.certifiedcode.us/legal/terms-of-services"
                              target="_blank"
                            >
                              {t("tos-link")}
                            </a>
                          </Text>
                        </Cell>
                        <Cell></Cell>
                      </Layout>
                    }
                  />
                </Card>
              }
            />
          </Modal>
          <Modal
            isOpen={shownSettingsModal}
            onRequestClose={() => setShownSettingsModal(false)}
            shouldCloseOnOverlayClick
            screen="desktop"
          >
            <CustomModalLayout
              primaryButtonText={t("save-button")}
              secondaryButtonText={t("cancel-button")}
              closeButtonProps={{
                skin: "dark",
                size: "small",
                onClick: () => setShownSettingsModal(false),
              }}
              showHeaderDivider={false}
              showFooterDivider={false}
              secondaryButtonOnClick={() => setShownSettingsModal(false)}
              primaryButtonOnClick={() => setSettings()}
              removeContentPadding
              title={t("connect-title")}
              content={
                <Page>
                  <Page.Content>
                    <Box marginTop={5} display="block">
                      <Layout>
                        <Cell span={12}>
                          <Box direction="vertical" gap="SP2">
                            <FormField label={t("channelid-label")}>
                              <Input
                                clearButton
                                value={channelId}
                                onChange={(e) => setChannelId(e.target.value)}
                              />
                            </FormField>
                            <FormField label={t("channelkey-label")}>
                              <Input
                                clearButton
                                value={channelKey}
                                onChange={(e) => setChannelKey(e.target.value)}
                              />
                            </FormField>
                          </Box>
                        </Cell>
                      </Layout>
                    </Box>
                  </Page.Content>
                </Page>
              }
            />
          </Modal>
          <Modal
            isOpen={isUpgradeModalOpen}
            shouldCloseOnOverlayClick={true}
            onRequestClose={() => setIsUpgradeModalOpen(false)}
          >
            <AnnouncementModalLayout
              theme="premium"
              title={t("upgrade-title")}
              primaryButtonText={t("upgrade-button")}
              linkText={t("learn-more")}
              primaryButtonOnClick={() => {
                window.open(
                  upgradeUrl
                );
              }}
              linkOnClick={() => {
                window.open(
                  "https://support.certifiedcode.us/en/articles/7997786-getting-started-with-line-pay-pay-button"
                );
              }}
              closeButtonProps={{
                skin: "dark",
                size: "small",
                onClick: () => setIsUpgradeModalOpen(false),
              }}
              helpButtonProps={{
                skin: "dark",
                size: "small",
                onClick: () => {
                  window.open(
                    "https://support.certifiedcode.us/en/articles/7997786-getting-started-with-line-pay-pay-button"
                  );
                },
              }}
            >
              <Text>
                Accept online payments via LINE Pay Button. Upgrade to accept
                more payments.
              </Text>
            </AnnouncementModalLayout>
          </Modal>

          <Layout>
            <Cell span={12}>
              <Card>
                <Card.Header
                  title={
                    <Box gap={"SP2"}>
                      <Heading size="medium" as="h2">
                        {t("online-heading")}
                      </Heading>
                      {isUpgraded ? (
                        <Badge size="tiny" skin={"success"}>
                          {t("ready-badge")}
                        </Badge>
                      ) : (
                        <FloatingHelper
                          target={
                            <Badge size="tiny" skin={"danger"}>
                              {t("limited-badge")}
                            </Badge>
                          }
                          content={
                            <FloatingHelper.Content
                              title={t("popup-title")}
                              body={t("trial-body")}
                            />
                          }
                          placement="right"
                        />
                      )}
                    </Box>
                  }
                  suffix={
                    <Button
                      size="small"
                      skin={open ? "destructive" : "premium"}
                      onClick={() => {
                        if (open) {
                          // Disconnect account
                          disconnectAccount();
                        } else {
                          // Connect account - open settings modal
                          setShownSettingsModal(true);
                        }
                      }}
                      disabled={isOpening || !isUpgraded}
                    >
                      {open ? t("disconnect-account") : t("connect-account")}
                    </Button>
                  }
                />
                {open && isUpgraded ? (
                  <>
                    <Card.Content>
                      <EmptyState
                        theme="section"
                        title={t("live-title")}
                        subtitle={t("live-subtitle")}
                      >
                        <TextButton
                          prefixIcon={<Icons.ExternalLink />}
                          as={"a"}
                          href={
                            (instanceData as any)["site"]
                              ? (instanceData as any)["site"]["url"]
                              : ""
                          }
                          target={"_blank"}
                        >
                          {t("live-button")}
                        </TextButton>
                      </EmptyState>
                    </Card.Content>{" "}
                  </>
                ) : (
                  <></>
                )}
              </Card>
            </Cell>
            <Cell>
              <PageSection title={t("suggested-title")} showDivider />
            </Cell>
            <Cell span={12}>
              <Card>
                <MarketingLayout
                  title={t("online-title")}
                  description={t("online-desc")}
                  actions={
                    <Box direction="horizontal" gap="SP1">
                      <Button
                        size="small"
                        skin="premium"
                        onClick={() => {
                          setIsBusinessAppModalOpened(true);
                        }}
                      >
                        {t("see-button")}
                      </Button>
                      <Button
                        size="small"
                        skin="inverted"
                        onClick={() => {
                          window.Intercom(
                            "showNewMessages",
                            t("msg-accept")
                          );
                        }}
                      >
                        {t("talk-button")}
                      </Button>
                    </Box>
                  }
                  size="tiny"
                  badge={<Badge size="small">{t("iap-badge")}</Badge>}
                  image={
                    <Box width="100%" align="right">
                      <Image
                        width="120px"
                        src="https://www.wix-pages.com/wix-design-system-employees/generic_upgrade.svg"
                        transparent
                      />
                    </Box>
                  }
                />
              </Card>
            </Cell>
            <Cell span={12}>
              <Card>
                <MarketingLayout
                  title={t("contact-title")}
                  description={t("contact-desc")}
                  actions={
                    <Button
                      size="small"
                      onClick={() => {
                        window.Intercom(
                          "showNewMessages",
                          t("msg-help")
                        );
                      }}
                    >
                      {t("live-chat-button")}
                    </Button>
                  }
                  size="tiny"
                  hiddenBadge
                  alignItems="stretch"
                  image={
                    <Box width="100%" align="right">
                      <Image
                        width="120px"
                        src="https://www.wix-pages.com/wix-design-system-employees/PromotionalBookingsUpgrade.svg"
                        transparent
                      />
                    </Box>
                  }
                />
              </Card>
            </Cell>
            <Cell span={12}>
              <Card>
                <MarketingLayout
                  size="tiny"
                  actions={
                    <Button
                      size="small"
                      priority="secondary"
                      suffixIcon={<Icons.WixForms />}
                      onClick={() => {
                        window.Intercom("startSurvey", 44499573);
                      }}
                    >
                      {t("feedback-button")}
                    </Button>
                  }
                  title={t("looking-title")}
                  description={t("looking-desc")}
                ></MarketingLayout>
              </Card>
            </Cell>
          </Layout>
        </Page.Content>
      </Page>
  );
}

export default App;
